import './Master.scss';
import 'data/array';
import { Contexts } from 'modules/core/ContextProcessorService';
import { BuilderFeatures } from '../builder/BuilderFeatures';
export class MasterController {
    static $inject = ['application', 'ApplicationService2', '$scope', 'SegmentService', 'HostingService', 'LoadingService', '$translate', 'ngToast', 'ContextProcessorService', 'ModalService'];
    constructor(application, ApplicationService2, $scope, SegmentService, HostingService, LoadingService, $translate, ngToast, ContextProcessorService, ModalService) {
        'ngInject';
        this.application = application;
        this.ApplicationService2 = ApplicationService2;
        this.$scope = $scope;
        this.SegmentService = SegmentService;
        this.HostingService = HostingService;
        this.LoadingService = LoadingService;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.ContextProcessorService = ContextProcessorService;
        this.ModalService = ModalService;
        this.isMasterOfflineFeature = false;
        this.localStorage = window.localStorage;
        this.STATE = 'initial';
        // Translate
        this.translateItems();
        // Initial Query
        this.query();
    }
    async $onInit() {
        this.childrens = this.getChildren();
        this.defaultChild = this.getDefaultChild();
        this.isMasterOfflineFeature = await BuilderFeatures.isMasterOfflineFeature();
    }
    async translateItems() {
        this.operatorTitle = await this.$translate('master.operator');
    }
    async query() {
        try {
            let applications;
            this.LoadingService.startLoading();
            await this.ContextProcessorService.waitForInitialization();
            if (this.ContextProcessorService.context === Contexts.Default ||
                this.ContextProcessorService.tenant.id === undefined) {
                applications = await this.ApplicationService2.getApplications();
            }
            else {
                const tenantId = this.ContextProcessorService.tenant.id;
                applications = await this.ApplicationService2.getApplications(tenantId);
            }
            this.applications = applications
                .filter((a) => a.shortName != this.application.shortName)
                .map(a => {
                if (a.template == 'undefined') {
                    a.template = 'SDK';
                }
                if (a.template == 'operator') {
                    a.template = this.operatorTitle;
                }
                this.ApplicationService2.isOnline(a)
                    .then(data => {
                    if (this.isMasterOfflineFeature) {
                        a.isOnline = data;
                    }
                    else {
                        a.isOnline = true;
                    }
                });
                return a;
            });
            if (!await this.ApplicationService2.isOnline(this.application)) {
                this.save();
            }
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    selectApplication(bot, application) {
        application.identity = bot.shortName + '@msging.net';
        application.longName = bot.name;
        application.shortName = bot.shortName;
        this.searchResults = [];
    }
    getDefaultChild() {
        const children = this.application.applicationJson.settings.children;
        return children.find((c) => c && c.isDefault);
    }
    getChildren() {
        const children = this.application.applicationJson.settings.children;
        return children
            .map((c, i) => {
            c.$id = i;
            this.ApplicationService2.isOnline(c)
                .then(data => {
                if (this.isMasterOfflineFeature) {
                    c.isOnline = data;
                }
                else {
                    c.isOnline = true;
                }
            });
            return c;
        })
            .filter((c) => c && !c.isDefault);
    }
    hasChild(application) {
        const children = this.application.applicationJson.settings.children;
        return (children.filter((c) => c &&
            c.$id != application.$id &&
            c.service.toLowerCase() ==
                application.service.toLowerCase()).length > 0);
    }
    isAvalidChatbot(application) {
        return this.applications.some((c) => c.shortName == application.shortName);
    }
    async publish(child, isEditing) {
        try {
            this.LoadingService.startLoading();
            const children = this.application.applicationJson.settings.children;
            const errorMsg71 = await this.$translate('utils.errorMsg.71');
            const errorMsg72 = await this.$translate('utils.errorMsg.72');
            const errorMsg73 = await this.$translate('utils.errorMsg.73');
            if (!this.isAvalidChatbot(child)) {
                this.ngToast.danger(errorMsg72);
                return false;
            }
            if (this.hasChild(child)) {
                this.ngToast.danger(errorMsg71);
                return false;
            }
            const defaultChild = this.getDefaultChild();
            if (isEditing &&
                !child.isDefault &&
                defaultChild &&
                (defaultChild.service == child.service ||
                    defaultChild.$id == child.$id)) {
                this.ngToast.danger(errorMsg73);
                return false;
            }
            //If has a default chatbot, it will be substituted by application
            if (defaultChild && child.isDefault) {
                defaultChild.isDefault = false;
            }
            if (!defaultChild) {
                child.isDefault = true;
            }
            if (typeof this.application.applicationJson.settings.children !=
                'object') {
                this.application.applicationJson.settings.children = [];
            }
            if (isEditing) {
                this.application.applicationJson.settings.children[child.$id] = child;
            }
            else {
                this.application.applicationJson.settings.children.push(child);
            }
            this.childrens = this.getChildren();
            this.defaultChild = this.getDefaultChild();
            await this.save();
            this.ngToast.success(await this.$translate('utils.successMsg.8'));
            return true;
        }
        catch (err) {
            const errorMsg10 = await this.$translate('utils.errorMsg.10');
            this.ngToast.danger(errorMsg10);
            throw err;
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    save() {
        return this.HostingService.publish(this.application, this.application.template, this.application.applicationJson);
    }
    onExclude(application) {
        this.application.applicationJson.settings.children = this.application.applicationJson.settings.children.filter(a => a.identity != application.identity);
        if (application.isDefault) {
            if (this.application.applicationJson.settings.children.length > 0) {
                this.application.applicationJson.settings.children[0].isDefault = true;
            }
        }
        this.LoadingService.startLoading();
        try {
            this.save();
            this.ngToast.success(this.$translate.instant('utils.successMsg.8'));
        }
        catch (err) {
            const errorMsg10 = this.$translate.instant('utils.errorMsg.10');
            this.ngToast.danger(errorMsg10);
            throw err;
        }
        finally {
            this.childrens = this.getChildren();
            this.defaultChild = this.getDefaultChild();
            this.$scope.$apply();
            this.LoadingService.stopLoading();
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
MasterController.$inject = ['application', 'ApplicationService2', '$scope', 'SegmentService', 'HostingService', 'LoadingService', '$translate', 'ngToast', 'ContextProcessorService', 'ModalService'];
